import AppRoute from "models/AppRoute"
import { Guid } from "@/types"

interface IOutgoingInvoiceViewRouteParams {
    invoiceId: Guid
}

const OutgoingInvoiceViewRoute = new AppRoute<IOutgoingInvoiceViewRouteParams, {}>({
    route: "/outgoing-invoice/:invoiceId/view",
    navbar: true,
    authRequired: true,
})

export default OutgoingInvoiceViewRoute
